import React from 'react';

import Accordion from "react-bootstrap/Accordion";
import {SecSubTitle, SecTitle, TitleWrap} from "../../components";

const Questions = ({questions,className})=> (
    <div className={`background-image ${className || ''} overflow-visible`} style={{backgroundImage: 'url(images/bg/sr-bg-1-1.png)'}}>
        <div className="container">
            <div className="container space-extra-bottom">
                <TitleWrap className="text-center space-top ">
                <SecTitle className="text-capitalize h1">Frequently Asked Questions</SecTitle>
            </TitleWrap>

        </div>


        <Accordion defaultActiveKey={questions[0].questionId} className="accordion-style1 layout2">
            {questions.map(item => (
                <Accordion.Item   key={item.questionId} eventKey={item.questionId}>
                    <Accordion.Header >{item.question}</Accordion.Header>
                    <Accordion.Body><p>{item.answer}</p></Accordion.Body>
                </Accordion.Item>
            ))}
        </Accordion>
    </div>
    </div>
)
;


export default Questions;